module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "sec_front"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Right off the bat, my thanks to the Big Four: André Schiffrin, my publisher for the past thirty-eight years; Tom Engelhardt, the nonpareil of editors; Sydney Lewis, more than a transcriber, an interpreter of indecipherable scrawlings and occasional critic; and Dan Terkel for keeping things moving.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My gratitude to Lonnie Bunch, president of the Chicago Historical Society, where I currently hang my hat, for granting me such latitude; to Usama Alshaibi, the sound engineer of the CHS, for his salvage job on my inept tapings; to Maria Lettiere, Sharon Lancaster, and Sylvia Landsman for help over and beyond the call of duty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My thanks to Patricia Sullivan for her book "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Days of Hope: Race and Democracy in the New Deal Era")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As in all my previous works, a salute to the scouts and, especially, to those who have granted me hours of their precious time. I list them in alphabetical order: Fran Ansley, Andrew Bae, Joe Bast, Bruce Bendinger, Adria Bernardi, Father Brendan Curran, Mary Cygan, Father Chuck Dahm, Leon Despres, Ed Flickinger, Darren Fowler, Mary Gaffney, Merle Hansen, Quentin Ikozeo, Thomas Jeffrey, Tony Judge, Mark Larson, Jack Levine, Herschel Ligon, Marian Mc-Partland, Jafar Moradi, Sandra Morales, Stella Nowicki, Hank Oettinger, McKinley Olson, Marie Perez, Crispino Peterino, Barbara Robbins, Steve Robinson, Tom Roeser, Walter Rosenblum, Ed Sadlowski, Florence Scala, Carol Steele, Gloria Steinem, Tish Valva, Tom Walsh, Robb Warden, Haskell Wexler, and Michael Wood.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47f8b4f7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Acknowledgments.vue
// module id = 69
// module chunks = 0